import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link as RouterLink, useLocation } from "react-router-dom";
import styled from "styled-components";
import { downloadResumeUtil } from "../common/downloadResumeUtil";

const Link = styled(RouterLink)`
  color: #ffffff;
  &:hover {
    text-decoration: none;
    color: yellow;
  }
`;
function NavBarComponent() {
  const location = useLocation();
  console.log("Location", location);

  return (
    <Navbar expand="lg" className="bg-body-tertiary" variant="dark">
      <Navbar.Brand href={"/"}>
        <img src="images/favicons/favicon.ico" alt="RJ"></img>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto" activeKey={location.pathname}>
          <Nav.Link as={Link} className="px-3" to={"/about-me"}>
            About Me
          </Nav.Link>
          <Nav.Link as={Link} className="px-3" to={"/qualifications"}>
            Education
          </Nav.Link>
          <Nav.Link as={Link} className="px-3" to={"/skills"}>
            Skills
          </Nav.Link>
          <Nav.Link as={Link} className="px-3" to={"/projects"}>
            Projects
          </Nav.Link>
          <Nav.Link as={Link} className="px-3" onClick={downloadResumeUtil}>
            Resume
          </Nav.Link>
          {/* <Nav.Link as={Link} className="px-3" eventKey={"/experience"}>
            Experience
          </Nav.Link> */}
          <Nav.Link as={Link} className="px-3" to={"/contact"}>
            Contact
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default NavBarComponent;
